import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationExtras } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(private router: Router) {

    }

    restrictedRoutes = ['/settings', '/analytics', '/plans-page'];

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let currentUser;
        const rememberMe = localStorage.getItem('rememberMe');

        if (rememberMe == 'true') {
            currentUser = JSON.parse(localStorage.getItem('currentUser'));
        }
        else {
            currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        }

        if (currentUser) {
            if (currentUser.user.user_account_type === 'supplementary' && this.restrictedRoutes.indexOf(state.url) > -1) {
                this.router.navigate(['/']);
                return false;
            }
            // if (state.url == '/additional-public-library-home' && currentUser.user.user_type == 'business' && currentUser.user.user_account_type == 'supplementary') {
            //     return false;
            // }
            return true;
        }
        const navigationExtras: NavigationExtras = {
            queryParams: {
                redirect_url: state.url
            }
        };
        this.router.navigate(['/'], navigationExtras);
        return false;
    }
}